import React from "react";
import { Hero, Section } from "../components/Page/Page.js";
import { legal } from "../data/content.js";

export default function LegalScreen({ kind }) {
  const [title, text] = legal[kind];
  return (
    <>
      <Hero title={title} />
      <Section><p>{text}</p></Section>
    </>
  );
}
